// extracted by mini-css-extract-plugin
export default {"container":"style_container__hVJsy","full":"style_full__iVUyE","loadding":"style_loadding__1eP+W","dot":"style_dot__e9LCs","jump":"style_jump__dBKrs"};